<template>
  <v-card>
    <v-card-title>現掛項目</v-card-title>
    <v-card-text class="text-body-1">
      <div>姓名：{{ walkin.person.姓名 }}</div>
      <div>年齡：{{ 年齡 }}</div>
      <div>身分證字號：{{ walkin.person.身分證字號 }}</div>
      <div>民眾可執行項目：</div>
      <div v-for="item of 健檢項目">
        <v-checkbox
          v-model="items"
          :value="item"
          class="mt-1"
          :label="`${item}`"
          hide-details
        ></v-checkbox>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="error" @click="$emit('close')">關閉</v-btn>
      <v-btn text color="primary" @click="handleWalkin">現掛</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import { 健檢項目 } from "@/libs/const.js";
export default {
  name: "walkDialog",
  props: ["walkin", "section"],
  data: () => ({
    items: [],
  }),
  async created() {
    this.items = this.walkin.items;
  },
  computed: {
    健檢項目() {
      return _.map(健檢項目, (value, key) => key);
    },
    年齡() {
      let birth = parseInt(this.walkin.person.出生年月日) + 19110000 + "";
      return dayjs().year() - dayjs(birth).year();
      // return dayjs().diff(this.walkin.person.出生年月日, "year");
    },
  },
  methods: {
    async handleWalkin() {
      if (this.items.length) {
        let payload = (
          await this.axios.post(`/dashboard/person/walkin`, {
            身分證字號: this.walkin.person.身分證字號,
            現掛項目: this.items,
            日期: this.section.日期,
            地點: this.section.地點,
          })
        ).data;
        await this.$emit("loadList");
        await this.$emit("singlePrint", payload);
        this.$emit("close");
        this.$toast.success("現掛完成!");
      } else {
        this.$toast.success("沒有現掛項目!");
      }
    },
  },
};
</script>

<style></style>
